// extracted by mini-css-extract-plugin
export default {"user":"styles_user__albVO","main_section":"styles_main_section__OE-48","left_banner":"styles_left_banner__z6hUy","right_section":"styles_right_section__Pq0UA"};